import React from "react";
import classNames from "classnames";
import { withStyles } from '@material-ui/core/styles';
import Tooltip from "@material-ui/core/Tooltip";

interface Props {
  className?: string;
  icon?: string;
  tooltip: any;
}

const DarkTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: 'rgba(0,0,0,0.8)',
        border:'none',
        textAlign: 'center',
        fontSize: 15,
        padding: '5px 10px'
    },
    arrow:{
        color: 'rgba(0,0,0,0.8)',
    }
}))(Tooltip);

const TooltipIcon = ({
  className,
  icon = "fas fa-question",
  tooltip
}: Props) => (
  <DarkTooltip interactive title={tooltip} arrow>
    <span className={classNames(className, "icon-circle")}>
      <i className={icon}></i>
    </span>
  </DarkTooltip>
);

export default TooltipIcon;
